import React from 'react';
import { jwtDecode } from 'jwt-decode';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from '../store/store';

const ROLE_CLAIM =
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';
const ALLOWED_ROLES = ['SuperAdmin', 'Admin'];

const getRoles = (token: string | null): string[] => {
  if (!token) return [];
  try {
    const decoded = jwtDecode<Record<string, unknown>>(token);
    const claim =
      decoded[ROLE_CLAIM] ??
      (decoded as Record<string, unknown>).role ??
      (decoded as Record<string, unknown>).roles;
    if (Array.isArray(claim)) return claim.map(String);
    return claim ? [String(claim)] : [];
  } catch {
    return [];
  }
};

interface PrivateRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated,
  );
  const jwtToken = useSelector((state: RootState) => state.auth.jwtToken);
  const token = jwtToken; // #28: лише in-memory JWT (більше не читаємо з localStorage)

  if (!isAuthenticated || !token) {
    return <Navigate to="/" replace />;
  }

  const isAdmin = getRoles(token).some((r) => ALLOWED_ROLES.includes(r));

  if (!isAdmin) {
    const logout = () => {
      localStorage.clear();
      window.location.href = '/';
    };
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'Ubuntu, sans-serif',
          color: '#152837',
          background: '#e7ebf2',
          textAlign: 'center',
          padding: 24,
        }}
      >
        <h2 style={{ margin: 0 }}>Доступ заборонено</h2>
        <p style={{ margin: 0, color: '#596987', maxWidth: 420 }}>
          Адміністративна панель доступна лише адміністраторам. Увійдіть під
          обліковим записом адміністратора.
        </p>
        <button
          onClick={logout}
          style={{
            padding: '10px 22px',
            borderRadius: 10,
            border: 'none',
            background: '#0a8081',
            color: '#ffffff',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Вийти
        </button>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
